import React from "react";
import {Box} from "@mui/material";
import {ColorSwatchPicker} from "../../../../../components/ColorSwatchPicker";
import {CAMPAIGN_PALETTE} from "../campaign-calendar/calendarUtils";
import {FieldHelper, FieldLabel} from "./formFieldShared";

export const CampaignColorField = ({value, onChange}) => (
  <Box>
    <FieldLabel>Calendar color</FieldLabel>
    <ColorSwatchPicker value={value} onChange={onChange} colors={CAMPAIGN_PALETTE}
                       defaultLabel={"Default"} defaultHint={"Lavender"}/>
    <FieldHelper>How this campaign looks on the calendar</FieldHelper>
  </Box>
);
